var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.clipCross,
          expression: "clipCross"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("裁剪宽度(米) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.clipWidth,
                  expression: "clipWidth"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { min: "0", step: "1", type: "range" },
              domProps: { value: _vm.clipWidth },
              on: {
                __r: function($event) {
                  _vm.clipWidth = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.clipWidth,
                  expression: "clipWidth"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { min: "0", step: "1", type: "number" },
              domProps: { value: _vm.clipWidth },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.clipWidth = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("裁剪高度(米) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.clipHeight,
                  expression: "clipHeight"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { min: "0", step: "1", type: "range" },
              domProps: { value: _vm.clipHeight },
              on: {
                __r: function($event) {
                  _vm.clipHeight = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.clipHeight,
                  expression: "clipHeight"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { min: "0", step: "1", type: "number" },
              domProps: { value: _vm.clipHeight },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.clipHeight = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("绕X轴旋转(度) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.pitch,
                  expression: "pitch"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { min: "0", max: "360", step: "1", type: "range" },
              domProps: { value: _vm.pitch },
              on: {
                __r: function($event) {
                  _vm.pitch = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.pitch,
                  expression: "pitch"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { min: "0", max: "360", step: "1", type: "number" },
              domProps: { value: _vm.pitch },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.pitch = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("绕Y轴旋转(度) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.roll,
                  expression: "roll"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { max: "360", min: "0", step: "1", type: "range" },
              domProps: { value: _vm.roll },
              on: {
                __r: function($event) {
                  _vm.roll = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.roll,
                  expression: "roll"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { max: "360", min: "0", step: "1", type: "number" },
              domProps: { value: _vm.roll },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.roll = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("绕Z轴旋转(度) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.heading,
                  expression: "heading"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { max: "360", min: "0", step: "1", type: "range" },
              domProps: { value: _vm.heading },
              on: {
                __r: function($event) {
                  _vm.heading = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.heading,
                  expression: "heading"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { max: "360", min: "0", step: "1", type: "number" },
              domProps: { value: _vm.heading },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.heading = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("拉伸(米) :")
          ]),
          _c("div", { staticClass: "sm-solider-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.extrude,
                  expression: "extrude"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "63%" },
              attrs: { min: "0", step: "1", type: "range" },
              domProps: { value: _vm.extrude },
              on: {
                __r: function($event) {
                  _vm.extrude = $event.target.value
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.extrude,
                  expression: "extrude"
                }
              ],
              staticClass: "min-solider",
              staticStyle: { width: "34%", height: "25px" },
              attrs: { min: "0", step: "1", type: "number" },
              domProps: { value: _vm.extrude },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.extrude = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.startCross }
            },
            [_vm._v(" 裁剪 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clearCross }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }